<template>
  <div class="video">
    <div id="dplayer"></div>
  </div>
</template>

<script>
import DPlayer from "dplayer";
import { startVideo, during } from "@/api/record";
export default {
  name: "crouseVideo",
  props: {
    info: Object,
  },
  data() {
    return {
      historyId: null,
    };
  },
  watch: {
    info(val) {
      this.handleOperate(val.videoUrl);
      // this.dp.switchVideo({
      //   url: val.videoUrl,
      // });
    },
  },
  mounted() {
    this.dp = new DPlayer({
      container: document.getElementById("dplayer"),
      video: {
        type: "hls",
      },
    });

    let vm = this;
    // 播放
    vm.dp.on("play", function () {
      if (vm.historyId) {
        vm.handleDuring();
      } else {
        vm.handleStart();
      }
    });
    // 暂停
    vm.dp.on("pause", function () {
      clearInterval(vm.timerId);
      console.log("暂停观看");
    });
    // 结束
    vm.dp.on("ended", function () {
      clearInterval(vm.timerId);
      console.log("结束观看");
    });

    // this.handleOperate(this.info.videoUrl);
  },
  deactivated() {
    clearInterval(this.timerId);
  },
  methods: {
    handleOperate(url) {
      this.dp.switchVideo({
        url,
      });
      if (!url) this.$message.warning('本章节无视频')
    },
    // 开始观看
    handleStart() {
      startVideo(this.$route.query.classChapterId).then((res) => {
        if (res.code == 0) {
          this.historyId = res.data;
          console.log("开始观看");
          if (this.historyId) {
            this.handleDuring();
          }
        } else {
          console.log(res.msg);
        }
      });
    },
    // 进行中
    handleDuring() {
      this.timerId && clearInterval(this.timerId);
      this.timerId = setInterval(() => {
        during(this.historyId).then((res) => {
          if (res.code == 0) {
            console.log("视频观看中...");
          } else {
            console.log(res.msg);
          }
        });
      }, 3000);
    },
  },
};
</script>

<style lang="less" scoped>
.video {
  width: 100%;
  height: 100%;

  #dplayer {
    width: 100%;
    height: 100%;
  }
}
</style>